var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lp-block-video-record"},[(_vm.value.data.video)?_c('div',[_c('block-video-viewer',{attrs:{"value":_vm.value}})],1):_c('div',[_c('div',[_c('video-recorder',{attrs:{"width":640,"height":480,"video":false,"screen":true},on:{"finishRecord":_vm.saveVideo}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }